<template>
  <Panel
    name="details-panel"
    collapses="right" 
    :collapsed="detailsPanelCollapsed"
    :has-spacing="true"
  >
    <template #panel-header>
      <DetailsPanelHeader title="Reisedetails" />
    </template> 

    <template #panel-content>
      <DetailsContentPane>
        <PageLoader 
          v-if="isCruiseLoading"
          title="Lade Cruise ..."
        />
      
        <template 
          v-else-if="!!selectedCruise && !!priceModel"
        >
          <DetailsOverview v-if="activeTab === 'overview'" />
          <DetailsCabin v-if="activeTab === 'cabin'" />
          <DetailsTransportation v-if="activeTab === 'transportation'" />
          <DetailsRoute v-if="activeTab === 'route'" />
          <DetailsPdfView v-if="activeTab === 'pdf'" />
        </template>
        <PageLoader 
          v-else 
          title="Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut..."
        />
      </DetailsContentPane>
    </template>
    
    <template #panel-footer>
      <DetailsOrderPanel />
    </template>
  </Panel>
</template>

<script lang="ts">
import PageLoader from '../common/PageLoader.vue'
import Panel from '../common/Panel.vue'

import { useCruiseStore, useDetailsStore, useUiStore } from '@/store'
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import DetailsCabin from './cabin/DetailsCabin.vue'
import DetailsContentPane from './DetailsContentPane.vue'
import DetailsPanelHeader from './DetailsPanelHeader.vue'
import DetailsOrderPanel from './order/DetailsOrderPanel.vue'
import DetailsOverview from './overview/DetailsOverview.vue'
import DetailsPdfView from './pdfview/DetailsPdfView.vue'
import DetailsRoute from './route/DetailsRoute.vue'
import DetailsTransportation from './transportation/DetailsTransportation.vue'

export default defineComponent({
  components: {
    Panel,
    DetailsContentPane,
    PageLoader,
    DetailsPanelHeader,
    DetailsOverview,
    DetailsTransportation,
    DetailsCabin,
    DetailsRoute,
    DetailsOrderPanel,
    DetailsPdfView,
  },

  computed: {
    ...mapState(useUiStore, {
      detailsPanelCollapsed: store => store.detailsPanelCollapsed,
      activeTab: store => store.detailsPanelActiveTab,
    }),
    ...mapState(useCruiseStore, {
      selectedCruise: store => store.cruise,
      isCruiseLoading: store => store.isCruiseLoading,
    }),
    ...mapState(useDetailsStore, {
      priceModel: store => store.priceModel,
    }),
  },
})
</script>
